import {Box, Tab, Tabs} from '@mui/material';
import {t} from 'i18next';
import './IngestionAnalyticsTabs.scss';
import {useState} from 'react';
import EsIndexing from '../es-indexing/EsIndexing';
import Analytics from '../analytics/Analytics';
import IndexManagement from '../index-management/IndexManagement';
import {setTabValue} from '../../../redux/slice/createCustomIndexSlice';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../redux/store';

interface IngestionAnalyticsTabsProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  className?: string;
}

interface TabData {
  label: string;
  content: React.ReactNode;
}

function TabPanel(props: Readonly<IngestionAnalyticsTabsProps>) {
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      data-testid={`ingestion-analytics-tabs-${index}`}
    >
      {value === index && (
        <div data-testid={`ingestion-analytics-tabs-child-${index}`}>
          {children}
        </div>
      )}
    </div>
  );
}

const IngestionAnalyticsTabs = () => {
  const dispatch = useDispatch();
  const {tabValue} = useSelector((state: RootState) => state.indexManagement);
  const [value, setValue] = useState(tabValue);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    dispatch(setTabValue(newValue));
  };

  const tabData: TabData[] = [
    {
      label: t('ingestions.ingestionAnalytics.tabs.labelEsIndexing'),
      content: <EsIndexing />,
    },
    {
      label: t('ingestions.ingestionAnalytics.tabs.labelAnalytics'),
      content: <Analytics />,
    },
    /* This code needs to uncommit for future release 1.1 */
    // {
    //   label: t('ingestions.ingestionAnalytics.tabs.labelIndexManagement'),
    //   content: <IndexManagement />,
    // },
  ];

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  return (
    <Box className="analytics-content">
      <Box className="tabs-section" data-testid="tabs-section">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Analytics tabs"
          className="tabs-content"
          data-testid="tabs"
        >
          {tabData.map((tab, index) => (
            <Tab
              key={tab.label}
              label={tab.label}
              className="tab-content"
              data-testid={`tab-${index}`}
              {...a11yProps(index)}
            />
          ))}
        </Tabs>
      </Box>
      <Box className="tabs-child">
        {tabData.map((tab, index) => (
          <TabPanel
            key={tab.label}
            value={value}
            index={index}
            data-testid={`tabpanel-${index}`}
          >
            {tab.content}
          </TabPanel>
        ))}
      </Box>
    </Box>
  );
};

export default IngestionAnalyticsTabs;
